/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CriteriaField } from '../../models/criteria-field';
import { Field } from '../../models/field';

export interface ApiMasterFieldGetByCriteriaPost$Params {
      body?: CriteriaField
}

export function apiMasterFieldGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterFieldGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Field>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterFieldGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Field>>;
    })
  );
}

apiMasterFieldGetByCriteriaPost.PATH = '/api/Master/Field/GetByCriteria';
